module.exports = __webpack_public_path__ + "images/fbce21fc482268c353a5222cccb0fb71.svg";